jQuery('.c-slider').slick({
  adaptiveHeight: true,
  cssEase: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
  dots: true,
  arrows: false,
});
